import styled from 'styled-components';

export const HeadingContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  h1 {
    margin: 0;
  }

  > h6 {
    margin: 0 8px 0;
    padding: 0;
    text-align: center;
    font-size: 18px;
    font-weight: normal;
  }
`;

export const Description = styled.p`
  width: 100%;
  margin-bottom: 24px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 1500px;
  margin-bottom: 16px;
`;
